export function pixeliseValue(val) {
  return val ? `${val}px` : '';
}
